import * as React from "react";

const SvgComponent = ({ height = "22px", width = "16px", color = "#fff", ...props }) => (
  <svg
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 16 22"
    cursor="pointer"
    {...props}
  >
    <path
      d="M15.965 18.197c0 1.792-3.362 3.261-7.52 3.261-4.158 0-7.52-1.469-7.52-3.261 0-1.295 1.719-2.39 4.209-2.938 1.394 2.09 2.714 3.66 2.813 3.809.25.299.722.299.971 0 .125-.15 1.42-1.718 2.839-3.81 2.49.548 4.208 1.644 4.208 2.939Zm-1.17-11.33c.1 3.387-4.358 9.288-5.852 11.205a.632.632 0 0 1-.996 0c-1.494-1.892-5.85-7.744-5.85-11.18 0-3.51 2.863-6.349 6.348-6.349 3.486 0 6.225 2.838 6.35 6.324Zm-4.084 0a2.274 2.274 0 0 0-2.266-2.266A2.274 2.274 0 0 0 6.18 6.867a2.274 2.274 0 0 0 2.266 2.266 2.274 2.274 0 0 0 2.266-2.266Z"
      fill={color}
    />
  </svg>
);

export default SvgComponent;